const backofficeStrings = {
  name: "Innstillinger",
  pageTitle: "@:backofficeStrings.name",
  pageHeader: "@:backofficeStrings.name",
  inconsistentConfigurationWarning: "Bruk av løsningen krever at \"@:generalSettingsStrings.enableOrgConfigurationForPayment\" er aktivert, og at refusjonsskjema er satt opp",
  futureConfigurationsOnlyWarning: "Det er ikke satt opp refusjonsskjema for dagens dato, krav vil ikke kunne opprettes før et refusjonsskjema er aktivt"
};

export default backofficeStrings;